// extracted by mini-css-extract-plugin
module.exports = {"leftRailWithSplitRow":"styles_leftRailWithSplitRow__1Y6yr","main":"styles_main__1dSB7","splitCol":"styles_splitCol__t87ja","split":"styles_split__hyN3w"};